import { render, staticRenderFns } from "./editor-video.vue?vue&type=template&id=a1785d86&scoped=true&"
import script from "./editor-video.vue?vue&type=script&lang=ts&"
export * from "./editor-video.vue?vue&type=script&lang=ts&"
import style0 from "./editor-video.vue?vue&type=style&index=0&id=a1785d86&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1785d86",
  null
  
)

export default component.exports